import '@oddbird/popover-polyfill'
import '../css/theme.css'
import './sprite'

import './modules/navigation'
import './modules/search'
import './modules/sooqr'
import './modules/stickyHeader'

import animations from './utils/animations'
import browser from './utils/browser'
import init from './utils/init'
import removeParams from './utils/remove-params'
import viewport from './utils/viewport'
import MegaMenu from '@vo/js/components/MegaMenu'
import Popover from '@vo/js/components/Popover'
import WindowObserver from '@vo/js/components/WindowObserver'

import {
    countdown,
    tabs,
    uspCarousel,
    filters,
    product,
    woobt,
    entryReadMore,
    clientType,
    cart,
    heroSwiper,
    cardsSwiper,
    toggle,
    Searchbar,
    readMore,
    dynamicPricingResizer
} from './modules'
import crossSell from '@vo/js/modules/crossSell'
import AddToCart from '@vo/js/modules/AddToCart'

// On Document ready
init(() => {
    WindowObserver.create()

    countdown()
    animations()
    browser.setAttributes()
    removeParams()
    tabs()
    uspCarousel()
    filters()
    product()
    woobt()
    entryReadMore()
    clientType()
    cart()
    viewport.init()
    heroSwiper()
    cardsSwiper()
    toggle()
    Searchbar.init()
    readMore()
    crossSell()
    AddToCart.initAll()
    dynamicPricingResizer()

    MegaMenu.init()

    document
        .querySelectorAll('[data-popover]')
        .forEach((element) => new Popover(element))

    // Add other components here...
    if (customData.isArchive && customData.archiveType) {
        loadArchives(customData.archiveType).catch(console.error)
    }

    if (document.querySelector('[data-vo-component=tab-group]')) {
        import('./modules/tabsNew')
    }

    if (document.querySelector('.snap-carousel')) {
        import('./modules/snapCarousels')
    }

    if (document.querySelector('[data-vo-component=accordion]')) {
        import('./modules/accordion')
    }

    document.body.classList.add('vo-dom-loaded')
})

async function loadArchives(archiveType) {
    // Add any custom javascript Archive classes here, by default the DefaultArchive is used
    // this is probably fine for most cases
    const { default: DefaultArchive } = await import('./utils/default-archive')
    DefaultArchive.init()
}
